import React from 'react'
import {
  CAvatar,
  CBadge,
  CDropdown,
  CDropdownDivider,
  CDropdownHeader,
  CDropdownItem,
  CDropdownMenu,
  CDropdownToggle,
} from '@coreui/react'
import { cilBell, cilLockLocked, cilSettings, cilTask, cilUser } from '@coreui/icons'
import CIcon from '@coreui/icons-react'

import defaultAvatar from './../../assets/images/default-avatar.png'
import { useHistory, Link } from 'react-router-dom'
import { useAppSelector } from '../../redux/hooks'
import { selectCurrentUser } from '../../redux/features/currentUser/currentUserSlice'

import { _print_model_data } from '../../utils/general'
import { _dictionary } from '../../utils/translate'

const AppHeaderDropdown = () => {
  const currentUser = useAppSelector(selectCurrentUser)
  const translate = _dictionary(currentUser?.active_language || null)
  const history = useHistory()

  const lockUserAccount = (event) => {
    // Handle error. (invalid jwt)
    if (typeof window !== 'undefined') localStorage.removeItem('jwt')
    history.go(0) // refresh the current page to redirect to login page
  }

  return (
    <CDropdown variant="nav-item">
      <CDropdownToggle placement="bottom-end" className="py-0" caret={false}>
        <CAvatar
          src={_print_model_data(currentUser?.avatar?.data.attributes.url) || defaultAvatar}
          size="md"
        />
      </CDropdownToggle>
      <CDropdownMenu className="pt-0" placement="bottom-end">
        <CDropdownHeader className="bg-light fw-semibold py-2">
          {translate('Account Settings')}
        </CDropdownHeader>
        <Link to={'/updates'} className="dropdown-item">
          <CIcon icon={cilBell} className="me-2" />
          {translate('Updates')}
          <CBadge color="info" className="ms-2">
            42
          </CBadge>
        </Link>
        <Link to={'/tasks'} className="dropdown-item">
          <CIcon icon={cilTask} className="me-2" />
          {translate('Tasks')}
          <CBadge color="danger" className="ms-2">
            42
          </CBadge>
        </Link>
        <CDropdownHeader className="bg-light fw-semibold py-2">
          {translate('Settings')}
        </CDropdownHeader>
        <Link to={'/me'} className="dropdown-item">
          <CIcon icon={cilUser} className="me-2" />
          {translate('Profile')}
        </Link>
        <Link to={'/settings'} className="dropdown-item">
          <CIcon icon={cilSettings} className="me-2" />
          {translate('Settings')}
        </Link>
        <CDropdownDivider />
        <Link to={'#'} className="dropdown-item" onClick={lockUserAccount}>
          <CIcon icon={cilLockLocked} className="me-2" />
          {translate('Lock Account')}
        </Link>
      </CDropdownMenu>
    </CDropdown>
  )
}

export default AppHeaderDropdown
